import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/effect-fade";

import { Link } from "gatsby";
import * as React from "react";
import {
  A11y,
  Autoplay,
  EffectFade,
  Navigation,
  Pagination,
} from "swiper/modules";
import { Swiper, useSwiper } from "swiper/react";

import { Section } from "styles";

import {
  HomeSliderWrapper,
  HomeSlideWrapper,
  ProgressBar,
  SlideProgress,
  SlideProgressContainer,
  SlideTitle,
} from "./Slider.styles";

const SLIDE_TIME = 5000;

type HomeSlideProps = {
  image: string;
  url: string;
  children: React.ReactNode;
};

export const HomeSlide = ({ children, image, url }: HomeSlideProps) => {
  return (
    <HomeSlideWrapper $backgroundImage={image}>
      <Link to={url}>
        <Section className="grid grid-cols-1 px-8 py-20 lg:grid-cols-2 lg:px-0 lg:py-40">
          {children}
        </Section>
      </Link>
    </HomeSlideWrapper>
  );
};

type SliderNavProps = {
  progressSlide1: React.MutableRefObject<null>;
  progressSlide2: React.MutableRefObject<null>;
  progressSlide3: React.MutableRefObject<null>;
  progressClassName: React.MutableRefObject<null>;
};

const SliderNav = ({
  progressClassName,
  progressSlide1,
  progressSlide2,
  progressSlide3,
}: SliderNavProps) => {
  const swiper = useSwiper();

  return (
    <SlideProgressContainer>
      <div ref={progressClassName}>
        <SlideProgress onClick={() => swiper.slideTo(0)}>
          <SlideTitle>Revolution</SlideTitle>
          <ProgressBar max="1" ref={progressSlide1} />
        </SlideProgress>
        <SlideProgress onClick={() => swiper.slideTo(1)}>
          <SlideTitle>Press Release</SlideTitle>
          <ProgressBar max="1" ref={progressSlide2} />
        </SlideProgress>
        <SlideProgress onClick={() => swiper.slideTo(2)}>
          <SlideTitle>Latest Blog</SlideTitle>
          <ProgressBar max="1" ref={progressSlide3} />
        </SlideProgress>
      </div>
    </SlideProgressContainer>
  );
};

type HomeSliderProps = {
  children: React.ReactNode;
};

export const HomeSlider = ({ children }: HomeSliderProps) => {
  const progressSlide1 = React.useRef(null);
  const progressSlide2 = React.useRef(null);
  const progressSlide3 = React.useRef(null);
  const progressClassName = React.useRef(null);
  const onAutoplayTimeLeft = (s: any, time: number, progress: number) => {
    progressSlide1.current.value = 1 - progress;
    progressSlide2.current.value = 1 - progress;
    progressSlide3.current.value = 1 - progress;
    progressClassName.current.className = `current-${s.realIndex + 1}`;
  };
  return (
    <HomeSliderWrapper>
      <Swiper
        slidesPerView={1}
        speed={1000}
        autoplay={{
          delay: SLIDE_TIME,
          disableOnInteraction: false,
        }}
        loop={true}
        effect="fade"
        enabled={true}
        pagination={{
          clickable: false,
          enabled: false,
        }}
        style={{ zIndex: 0 }}
        onAutoplayTimeLeft={onAutoplayTimeLeft}
        navigation
        modules={[EffectFade, Autoplay, Navigation, Pagination, A11y]}
      >
        {children}
        <SliderNav
          progressSlide1={progressSlide1}
          progressSlide2={progressSlide2}
          progressSlide3={progressSlide3}
          progressClassName={progressClassName}
        />
      </Swiper>
    </HomeSliderWrapper>
  );
};
